import React, { useEffect } from "react";

import { Link } from "react-router-dom";
import ActivityBar from "../../components/Reusable/ActivityBar/ActivityBar";
import { Box, Tab, Tabs, Button, Typography, Paper, Pagination, styled, Modal, DialogActions } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import RoutineStyle from "../../GlobalPolicies/RoutineUpload.module.css";
import ContactusDialog from "./ContactusDialog";
import { borderRadius, display } from "@mui/system";
import uploadedImg from "../../assets/images/img_jobdata.png";
import { apiService } from "../../api/apiService";
import { useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';


const Help: React.FC = () => {
  const { instance } = useMsal();
  // const [value, setValue] = React.useState('1');

  // const handleChange = (event: React.SyntheticEvent, newValue: string) => {
  //     setValue(newValue);

  // };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '1px solid #fff',
    boxShadow: 24,
    borderRadius: '8px',
    p: 2,
  };

  const [value, setValue] = React.useState('1');
  const [openDialog, setOpenDialog] = React.useState(false);
  const [userQueryData, setUserQueryData] = React.useState<any[]>([]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = (query: any) => {
    setCurrentQuery(query);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const [currentQuery, setCurrentQuery] = React.useState<any>(null);


  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleDialogOpen = () => setOpenDialog(true);
  const handleDialogClose = () => setOpenDialog(false);
  const breadcrumbs = [
    <Link key="1" color="#000" to="/">
      Home
    </Link>,
    <Link key="2" color="#000" to="/">
      Help
    </Link>,
  ];

  const getUserQueryData = async () => {
    setUserQueryData([]);
    const response = await apiService("/ops/my_queries", "GET", undefined, undefined, instance as PublicClientApplication);
    console.log(response);
    if (response?.status === 'success') {
      setUserQueryData(response?.data);
    } else {
      console.error("Error fetching data:", response?.statusText);
    }
  };

  useEffect(() => {
    getUserQueryData();
  }
    , [openDialog]);

  // Reusable component for displaying query cards
  const QueryCard: React.FC<{ item: any; onView: () => void }> = ({ item, onView }) => (
    <Paper sx={{ padding: "20px", marginTop: "20px", marginBottom: "20px", marginLeft: "20px" }} elevation={0}>
      <Box sx={{ display: "flex", justifyContent: "space-between", padding: "10px" }}>
        <Box>
          <Typography sx={{ fontSize: "12px", fontWeight: "600", color: "#1e1e1ea3" }}>Date</Typography>
          <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#000" }}>
            {new Date(item?.created_at).toLocaleDateString("en-GB")}
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontSize: "12px", fontWeight: "600", color: "#1e1e1ea3" }}>Center</Typography>
          <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#000" }}>{item?.management}</Typography>
        </Box>
        <Box>
          <Typography sx={{ fontSize: "12px", fontWeight: "600", color: "#1e1e1ea3" }}>Type of Issue</Typography>
          <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#000" }}>{item?.type_of_issue}</Typography>
        </Box>
        <Box>
          <Typography sx={{ fontSize: "12px", fontWeight: "600", color: "#1e1e1ea3" }}>Message</Typography>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#000",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "400px",
            }}
          >
            {item?.message}
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontSize: "12px", fontWeight: "600", color: "#1e1e1ea3" }}>Status</Typography>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              color: item?.status === "Pending" ? "#FF5C00" : "#0E711D",
            }}
          >
            {item?.status}
          </Typography>
        </Box>
        <Box>
          <Button
            variant="contained"
            sx={{ padding: "10px 20px", borderRadius: "5px", backgroundColor: "#fff" }}
            onClick={onView}
          >
            View
          </Button>
        </Box>
      </Box>
    </Paper>
  );

  return (
    <>
      <ActivityBar breadcrumbs={breadcrumbs} />
      <Box sx={{ width: "100%", typography: "body1" }}>
        <Box sx={{ padding: "20px", pt: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px", fontWeight: "600", color: "#000" }}>Query Status</Typography>
          <Button variant="contained" sx={{ padding: "10px 20px", borderRadius: "5px" }} onClick={handleDialogOpen}>
            Contact Us
          </Button>
        </Box>
        <TabContext value={value}>
          <Paper sx={{ padding: "20px", pb: "0", marginLeft: "20px" }} elevation={0}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                <Tab label="All" value="1" />
                <Tab label="Pending" value="2" />
                <Tab label="Resolved" value="3" />
              </TabList>
            </Box>
          </Paper>

          {userQueryData?.length > 0 ? (
            <>
              <TabPanel value="1">
                {userQueryData.map((item) => (
                 <QueryCard key={item.id} item={item} onView={() => handleOpen(item)} />
                ))}
              </TabPanel>

              <TabPanel value="2">
                {userQueryData
                  .filter((item) => item.status === "Pending")
                  .map((item) => (
                    <QueryCard key={item.id} item={item} onView={() => handleOpen(item)} />
                  ))}
              </TabPanel>

              <TabPanel value="3">
                {userQueryData
                  .filter((item) => item.status === "Resolved")
                  .map((item) => (
                    <QueryCard key={item.id} item={item} onView={() => handleOpen(item)} />
                  ))}
              </TabPanel>
            </>
          ) : (
            <Typography sx={{textAlign:'center', pt:1}}>You have not raised any queries yet!</Typography>
          )}
        </TabContext>

        <ContactusDialog open={openDialog} onClose={handleDialogClose} />
        <div>
          {/* <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" fontWeight={600} fontSize="18px">
                Uploaded File
              </Typography>

              <img
                src={uploadedImg}
                alt="Uploaded"
                style={{ width: "400px", height: "auto", borderRadius: "8px", marginTop: "10px" }}
              />

              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                Message
              </Typography>

              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#000",
                  border: "1px solid #000",
                  padding: "10px",
                  borderRadius: "5px",
                  marginTop: "10px",
                  width: "100%",
                }}
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque at erat nec ligula
                facilisis tincidunt. Donec ac nunc id enim efficitur facilisis.
              </Typography>

              <DialogActions sx={{ paddingTop: "20px", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{
                    backgroundColor: "#000",
                    color: "#fff",
                    padding: "10px 20px",
                    borderRadius: "5px",
                  }}
                >
                  Close
                </Button>
              </DialogActions>
            </Box>
          </Modal> */}

<Modal
  open={open}
  onClose={handleClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={style}>
    <Typography id="modal-modal-title" fontWeight={600} fontSize="18px">
      Query Details
    </Typography>

    {currentQuery?.doc_path && (
      <img
        src={currentQuery.doc_path} // Make sure your API returns doc_path URLs
        alt="Uploaded"
        style={{ width: "400px", height: "auto", borderRadius: "8px", marginTop: "10px" }}
      />
    )}

    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
      Message
    </Typography>

    <Typography
      sx={{
        fontSize: "14px",
        fontWeight: "600",
        color: "#000",
        border: "1px solid #000",
        padding: "10px",
        borderRadius: "5px",
        marginTop: "10px",
        width: "100%",
      }}
    >
      {currentQuery?.message || "No message available"}
    </Typography>

    <DialogActions sx={{ paddingTop: "20px", justifyContent: "flex-end" }}>
      <Button
        variant="contained"
        onClick={handleClose}
        sx={{
          backgroundColor: "#000",
          color: "#fff",
          padding: "10px 20px",
          borderRadius: "5px",
        }}
      >
        Close
      </Button>
    </DialogActions>
  </Box>
</Modal>
        </div>

      </Box>
    </>
  )
}
export default Help;